import {Injectable, signal} from '@angular/core';
import {OrderDTO} from "@features/sales/domain/models/order/order.model";
import {SynchronizableStore} from "@platform/storage/application/storage.synchronizer";

export interface OrderState {
  readonly orders: OrderDTO[];
}

export const INITIAL_ORDER_STATE: OrderState = {
  orders: []
};

@Injectable({providedIn: 'root'})
export class OrderStore implements SynchronizableStore<OrderState> {
  private readonly _state = signal<OrderState>(INITIAL_ORDER_STATE);
  readonly state = this._state.asReadonly();

  saveOrder(order: OrderDTO): void {
    const orders = this._state().orders;
    const exists = orders.some(o => o.id === order.id);

    const next = exists
      ? orders.map(o => o.id === order.id ? order : o)
      : [...orders, order];

    this.patch({orders: next});
  }

  removeOrder(orderId: string): void {
    this.patch({orders: this._state().orders.filter(o => o.id !== orderId)});
  }

  reset(): void {
    this._state.set(INITIAL_ORDER_STATE);
  }

  patch(partial: Partial<OrderState>): void {
    this._state.update((current) => ({...current, ...partial}));
  }
}
